'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalCloseButton = require('../../lib/ModalCloseButton');

var _ModalCloseButton2 = _interopRequireDefault(_ModalCloseButton);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'closeClickableArea': 'Default__closeClickableArea___H4Qno',
  'closeIcon': 'Default__closeIcon___39hKL',
  'closeButtonDisabled': 'Default__closeButtonDisabled___1LelM'
};

var DefaultModalCloseButton = (0, _mergeThemeHoc2.default)(style)(_ModalCloseButton2.default);
DefaultModalCloseButton.displayName = 'DefaultModalCloseButton';
exports.default = DefaultModalCloseButton;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/ModalCloseButton/index.js
// module id = 759
// module chunks = 4 5 8 9 14